import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "3", x2: "21", y1: "9", y2: "9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m15 14-3 3-3-3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "PanelTopOpen";
const PanelTopOpen = memo(themed(Icon));
export {
  PanelTopOpen
};
//# sourceMappingURL=panel-top-open.js.map
